@if (alarms && alarms.alarms.length !== 0) {
  <div class="table-responsive">
    <table class="grayed-table table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table text-nowrap alarms-table">
      <thead>
        <tr>
          <th class="text-left pr-1 pl-3 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'turbineCodeMonitor')">{{"ALARMS.WIND_TURBINE" |translate}}</app-sort>
          </th>
          <th class="text-left px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'alarmCategory')">{{"ALARMS.CATEGORY" |translate}}</app-sort>
          </th>
          <th class="text-left px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'code')">{{"ALARMS.ALARM_CODE" |translate}}</app-sort>
          </th>
          <!-- <th class="px-1 w-auto">
          <app-sort (sortChanged)="sortChanged($event, 'description')">{{"ALARMS.ALARM_DESC" |translate}}</app-sort>
        </th> -->
        <th class="text-left px-1 w-auto">
          <app-sort (sortChanged)="sortChanged($event, 'createTS')">{{"ALARMS.START_TIME" |translate}}</app-sort>
        </th>
        @if (showOnFullsize) {
          <th class="text-left px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'closeTS')">{{"ALARMS.END_TIME" |translate}}</app-sort>
          </th>
        }
        <th class="text-left pr-3 pl-1 w-auto">
          <app-sort (sortChanged)="sortChanged($event, 'durationms')">{{"ALARMS.DURATION" |translate}}</app-sort>
        </th>
        @if (showOnFullsize) {
          <th class="text-left px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'productionLoss')">{{"ALARMS.PROD_LOSS" |translate}}</app-sort>
          </th>
        }
        @if (showOnFullsize) {
          <th class="text-left px-1 w-auto">
            <app-sort (sortChanged)="sortChanged($event, 'isOpen')">{{"ALARMS.ALARM_STATUS" |translate}}</app-sort>
          </th>
        }
        <th class="text-left px-1 w-auto">
          {{"ALARMS.DETAILS" |translate}}
        </th>
      </tr>
    </thead>
    <tbody>
      @for (alarm of alarms?.alarms; track alarm; let i = $index) {
        @if (!showAll ? (i < alarms?.maxNumberOfRows) : (i < alarms?.alarms.length)) {
          <tr>
            <td class="text-left text-primary font-weight-bold pr-1 pl-3 w-auto clickable">
              <a [routerLink]="['/monitor/turbine/', alarm?.turbineSerial, '1']" [queryParams]="{ alarms: 'alarms' }" class="font-weight-bold text-primary" [matTooltip]="'ALARMS.TURBINE_DETAILS' | translate">
                {{ alarm?.turbineCode | noUnderscore }}
              </a>
            </td>
            <td class="text-left text-primary w-auto">
              <i class="fas fa-circle mr-2" [style.color]="alarm?.categoryColor"></i>
              <span>{{'ALARMS.' + alarm?.alarmCategory | translate}}</span>
            </td>
            <td class="text-left px-1 w-auto">
              <a class="text-primary">
                <div class="text-primary font-size-small">{{alarm?.code}}</div>
                @if (alarm?.description.length <= 15 || isExpanded) {
                  <div class="font-size-very-small text-font" [title]="alarm?.description">
                    {{alarm?.description}}
                  </div>
                }
                @if (alarm?.description.length > 15 && !isExpanded) {
                  <div class="font-size-very-small text-font" [title]="alarm?.description">
                    {{alarm?.description.substr(0, 15)}}...
                  </div>
                }
              </a>
            </td>
            <!-- <td class="text-center text-primary px-1 w-auto" [routerLink]="['/troubleshoot/turbine/' + alarm?.turbineSerial + '/alarm/' + alarm?.id]">
            <span *ngIf="alarm?.description.length > 15" (mouseover)="getTool($event, alarm)" (mouseleave)="showTool = false;">
              {{ alarm?.description.substr(0, 15) }}...
            </span>
            <span *ngIf="alarm?.description.length <= 15"> {{ alarm?.description }} </span>
            <div *ngIf="showTool && alarm?.id === fullDesc.id" class="popup position-fixed card shadow border-dark p-3" [style.top.px]="toolTop" [style.left.px]="toolLeft">
              {{fullDesc.description}}
            </div>
          </td> -->
          <td class="text-left text-primary px-1 w-auto">
            <div class="text-primary font-size-small" > {{alarm?.createTS | dateTimeFormatPipe: 'ts': tz.selectedOption}}</div>
            <div class="font-size-very-small text-font" > {{alarm?.createTS | dateTimeFormatPipe: 'dmy': tz.selectedOption}}</div>
          </td>
          @if (showOnFullsize) {
            <td class="text-left text-primary px-1 w-auto">
              {{ !alarm?.isOpen ? (alarm?.closeTS | dateTimeFormatPipe: 'dmt': tz.selectedOption) : '-' }}
            </td>
          }
          <td class="text-left text-primary px-1 w-auto">
            <div class="text-primary font-size-small"> {{ alarm?.durationText }} </div>
            <div class="font-size-very-small text-font"> {{ alarm?.durationDHMS }} </div>
          </td>
          @if (showOnFullsize) {
            <td class="text-left text-primary px-1 w-auto">
              {{ alarm.productionLoss | number: '1.1-1' | customNumberFormat }} {{alarm.productionUnit}}
            </td>
          }
          @if (showOnFullsize) {
            <td class="text-left text-primary px-1 w-auto" >
              {{ alarm?.isOpen ? 'Open' : 'Close' }}
            </td>
          }
          <td class="text-left text-primary px-1 w-auto" [routerLink]="['/troubleshoot/turbine/' + alarm?.turbineSerial + '/alarm/' + alarm?.id]">
            <button
              data-testid="monitor-redirect-to-alarm-button"
              class="btn cursor-pointer"
              (click)="redirectToSingleTicket(ticket)">
              <i class="far fa-external-link-alt text-primary"
                [matTooltip]="'ALARMS.ALARM_DETAILS' | translate">
              </i>
            </button>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
@if (alarms.maxNumberOfRows < alarms.alarms.length) {
  <app-show-all [numberOfElements]="alarms.alarms.length" (changed)="toggleShowAll($event)"></app-show-all>
}
</div>
}

@if (alarms && alarms.alarms.length === 0) {
  <div class="row">
    <div class="col p-3 text-center">{{"ALARMS.NO_ALARMS" |translate}}</div>
  </div>
}